import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Pagination,
} from '@printdeal/ui-library';

interface QuoteListPaginationProps {
  quotesPerPage: number;
  currentPage: number;
  quoteTotal: number;
  setCurrentPage: (activePage: number) => void;
}

const QuoteListPagination = ({
  quotesPerPage,
  currentPage,
  quoteTotal,
  setCurrentPage,
}: QuoteListPaginationProps) => {
  const intl = useIntl();

  return (
    <Pagination
      total={quoteTotal}
      currentPage={currentPage}
      aria-label={intl.formatMessage({ id: 'general.pagination.label', defaultMessage: 'Pagination' })}
      perPage={quotesPerPage}
      siblingPages={3}
      className="pd-justify-center"
    >
      {({ pages, totalPages }) => (
        <>
          <Pagination.Button as="button" variant="prev" onClick={setCurrentPage}>
            <FormattedMessage id="general.pagination.button.previous" defaultMessage="Previous" />
          </Pagination.Button>

          <Pagination.Items className="pd-hidden sm:pd-flex">
            {pages.map((pageNumber) => <Pagination.Item as="button" key={pageNumber} onClick={setCurrentPage} />)}
          </Pagination.Items>
          <Pagination.Label className="sm:pd-hidden">
            <FormattedMessage
              id="general.pagination.mobileText"
              defaultMessage="Page {pageNumber} of {totalPages}"
              values={{
                pageNumber: currentPage,
                totalPages,
              }}
            />
          </Pagination.Label>
          <Pagination.Button as="button" variant="next" onClick={setCurrentPage}>
            <FormattedMessage id="general.pagination.button.Next" defaultMessage="Next" />
          </Pagination.Button>
        </>
      )}
    </Pagination>
  );
};

export default QuoteListPagination;
